import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import AreasOfWorkSection from "../sections/AreasOfWorkSection";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { ContentCutOutlined } from "@mui/icons-material";
import { Content } from "@radix-ui/react-navigation-menu";
import ScrollStory from "../sections/ScrollStory";
import { useAuth } from "../../hooks/useAuth";


export default function AddOurValuesForm({ previousValues, onAddcategory }) {

  const CATEGORY_FORM_STORAGE_KEY = 'ourValuesFormState';
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [orgValues,setOrgValues] = useState([])
  const location = useLocation()
  const [uploadingImage,  setUploadingImage] = useState(false)
 const {user} = useAuth()
  const [content, setContent] = useState({
    title: "",
    text: "",
    img: "",
  });

  const [tabPreviewCreate, setTabPreviewCreate] = useState(0); // 0 = New, 1 = Preview
  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

  // 

  // create of work categories
  
    const { request: createCategory, data:createCategoryData, error:createCategoryError} = useApi(onAddcategory);
              
        useEffect(()=>{
          if (createCategoryData?.status===200) {
            toast.success(`${JSON.stringify(createCategoryData?.data,null,2)}`,{position: "top-center"});
            setOpen(false);
            window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);
            setContent({
              title: "",
              text: "",
              img: "",
            })
            // setAreas(createCategoryData?.data);
            navigate('/staff/organisation/',{state: {redirect:"list-org"}})
          }
        // eslint-disable-next-line
        },[createCategoryData])

        useEffect(()=>{

          if(previousValues){
            console.log(previousValues)
            setOrgValues(previousValues?.org_metadata?.values)
          }
        },[previousValues,location])
      
        useEffect(()=>{
            if(createCategoryError){
                toast.error(`${JSON.stringify(createCategoryError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[createCategoryError])
    // End create area of work categories
  // 
      useEffect(()=>{
        if(content?.title && content?.text && content?.img){
          setOrgValues((prev) =>([...prev, content]));
        }
      },[content])

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // setContent((prev) => {...prev, { [name]: value }});
    setContent(prev => ({ ...prev, [name]: value }));
    
    window.localStorage.setItem(CATEGORY_FORM_STORAGE_KEY, JSON.stringify(content));
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Convert to local preview URL
      const previewUrl = URL.createObjectURL(file);
      setContent((prev) => ({ ...prev, value: previewUrl }));
      
      const formData = new FormData();
      formData.append("image", file);
      setUploadingImage(true)
      try{
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
          const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
          // const res = await fetch("/cms/ftp-files/", {
          method: "POST",
          body: formData, // don't add headers here
        });
      // console.log(res)
      if(res?.status===201){
        let result = await res.json()
        // console.log("Upload urls: ",result)
        setContent((prevData)=>({
          ...prevData,
          img: result?.path,
        }));
        setUploadingImage(false)
      // setMaterialUrl(event,event.target.value)
        // setUploadUrls(prev=>res?.data)
        // setConstFileUpload(false)
      }else{
        console.log(res)
      }
      }catch(error){
        console.log(error)
      }
  
      }
  }



  const handleSubmit = () => {
    if (!content.title) return alert("Please provide a title value.");
    if (!content.text) return alert("Please provide a text value.");

    const dataToSend = {
      org_metadata: {values: orgValues},
      id: user?.user?.org,
    }
    createCategory(user?.user?.org,dataToSend);
    // setContent({ type: "text", heading: "", value: "" });
    
  };

  useEffect(() => {
    const saved = window.localStorage.getItem(CATEGORY_FORM_STORAGE_KEY);
    if (saved) {
      try {
        const obj = JSON.parse(saved);
        // if (obj.title) settitle(obj.title);
        // if (obj.alias) setAlias(obj.alias);
        setContent(obj);
      } catch (err) {
        console.error('Could not parse saved value form state', err);
      }
    }
  }, []);



  // window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);

  return (<>
      {/* Add category Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add Values Statement
      </Button>

      {/* Popup Form */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Our values Statement</DialogTitle>
        <DialogContent>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography
            sx={{
                mb:5,
            }}
            >Add an item to the list of our values statements on organisation website (what we are item) that represents the values of your organization - such as Champion Peace, etc. 
            </Typography>

            <>
            <Tabs
              value={tabPreviewCreate}
              onChange={(e, newValue) => setTabPreviewCreate(newValue)}
              centered
              sx={{ mb: 1 }}
            >
              <Tab label="New value" />
              <Tab label="Preview" />
            </Tabs>
            {tabPreviewCreate === 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            {/* Category title */}
            <TextField
              name="title"
              label="title"
              value={content.title}
              onChange={handleChange}
              fullWidth
            >
            </TextField>

            <TextField
              name="text"
              label="text description"
              placeholder="explain the value inline with your organisation briefly ..."
              value={content.text}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={4}
            ></TextField>
            

            {/* Category Image Introduction */}
            <>
              <Tabs
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
                centered
                sx={{ mb: 1 }}
              >
                <Tab label="Value Image Representation Link" />
                <Tab label="Upload Value Image Representation" />
              </Tabs>

              {tabIndex === 0 ? (
                <TextField
                  name="img"
                  label="image Link"
                  value={content.img}
                  onChange={handleChange}
                  fullWidth
                />
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  {content?.img ? (
                    content?.img?.length >= 0 ? (
                      <img
                        src={content.img}
                        alt="preview"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        File selected: {content?.img.split("/").pop()}
                      </Typography>
                    )
                  ) : (
                    <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                  )}

                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    loading ={uploadingImage}
                  >
                    {content.img ? "Click Change File" : "Click to Upload File"}
                  </Button>
                  <input
                    type="file"
                    accept={"image/*"}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              )}
            </>
            </Box>
            ):
            (
              // <AreasOfWorkSection singleView={[category,]} />
              <ScrollStory ourValues={orgValues}/>
            )
            } 
        </>
        </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
